export default () => {
    return (
        <svg
            width="65"
            height="24"
            viewBox="0 0 65 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M0.863636 5.81818V0.727272H21.0909V5.81818H14.0909V24H7.86364V5.81818H0.863636ZM39.8324 0.727272V5.81818H29.7869V24H23.4688V0.727272H39.8324ZM48.9602 0.727272L52.7784 7.5H52.9602L56.8239 0.727272H63.8693L56.9148 12.3636L64.142 24H56.9148L52.9602 17.0909H52.7784L48.8239 24H41.642L48.7784 12.3636L41.8693 0.727272H48.9602Z"
                fill="#1F1F1F"
            />
        </svg>
    );
};
